import { SettingOutlined } from '@ant-design/icons'
import type { RouteConfig } from '@/types/route'
// import React from 'react'

export const routeConfig: RouteConfig = {
    title: 'route.system',
    icon: <SettingOutlined />,
    layout: true,
    
    sort: 10
}